import dayjs from 'dayjs';
import { isNil } from 'lodash-es';

export const DATE_FORMATS = {
  dateTime: 'DD MMM YYYY, HH:mm',
  time: 'HH:mm',
  preciseTime: 'HH:mm:ss',
  shortDate: 'MMM D, YYYY',
  longDate: 'MMMM DD, YYYY',
  shortDateNoYear: 'DD MMM',
  shortDateWithTime: 'HH:mm, DD MMM',
  longDateNoDay: 'MMMM YYYY',
  shortMonth: 'MMM',
  calendar: 'DD/MM/YYYY',
  calendarTime: 'DD/MM/YYYY HH:mm',
  input: 'YYYY-MM-DD',
  inputTime: 'YYYY-MM-DD HH:mm',
  dateAtTime: 'DD MMM YYYY [at] HH:mm',
};

/**
 * - dateTime: 06 Aug 2016, 15:40
 * - time: 15:40
 * - preciseTime: '15:40:30',
 * - shortDate: Aug 6, 2018
 * - longDate: August 16, 2018
 * - shortDateNoYear: 06 Aug',
 * - longDateNoDay: August 2018,
 * - shortMonth: Aug
 * - calendar: 06/08/2018
 * - calendarTime: 06/08/2018 15:40
 * - input: 2018-08-06
 * - inputTime: 2018-08-06 15:40
 * - dateAtTime: 06 Aug 2018 at 15:40
 */
export type DateFormat = keyof typeof DATE_FORMATS;

/**
 * Format a date.
 *
 * @param date to formate
 * @param format transformation :
 * - dateTime: 06 Aug 2016, 15:40
 * - time: 15:40
 * - preciseTime: '15:40:30',
 * - shortDate: Aug 6, 2018
 * - longDate: August 16, 2018
 * - shortDateNoYear: 06 Aug',
 * - longDateNoDay: August 2018,
 * - shortMonth: Aug
 * - calendar: 06/08/2018
 * - calendarTime: 06/08/2018 15:40
 * - input: 2018-08-06
 * - inputTime: 2018-08-06 15:40
 * - dateAtTime: 06 Aug 2018 at 15:40
 */
const formatDate = (date: Date | string | number, format: DateFormat = 'dateTime'): string => {
  const dateFormat = DATE_FORMATS[format];

  if (!isNil(dateFormat)) {
    return dayjs(date).format(dateFormat);
  }

  // TODO: add propper error handeling
  throw new Error('Unexpected format');
};

export default formatDate;
